import { TextField } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { handleConnectionDetailChange } from '../../../utils';

interface BigQueryFieldsProps {
  isEditable: boolean;
  formValues: Record<string, string | string[]>;
  handleInputChange: (name: string, value: string) => void;
  onValidityChange?: (isValid: boolean) => void;
}

// const BIGQUERY_IAP_TRANSACTIONS_TABLE_NAME_REGEX =
//   /^.*\.cohorts\.iap_transactions$/;
// const BIGQUERY_IAA_TRANSACTIONS_TABLE_NAME_REGEX =
//   /^.*\.cohorts\.iaa_transactions$/;
// const BIGQUERY_UA_SPENDS_TABLE_NAME_REGEX = /^.*\.cohorts\.ua_spends$/;

const BigQueryFields: React.FC<BigQueryFieldsProps> = ({
  isEditable,
  formValues,
  handleInputChange,
  onValidityChange,
}) => {
  const connectionDetails = JSON.parse((formValues.connectionDetails as string) || '{}');
  const [isTouched, setIsTouched] = useState({
    iapTransactionsTableName: false,
    iaaTransactionsTableName: false,
    uaSpendsTableName: false,
  });

  useEffect(() => {
    const isIAPValid = !!connectionDetails.iapTransactionsTableName;
    const isIAAValid = !!connectionDetails.iaaTransactionsTableName;
    const isUAValid = !!connectionDetails.uaSpendsTableName;

    const isAllValid = isIAPValid && isIAAValid && isUAValid;
    onValidityChange?.(isAllValid);
  }, [
    connectionDetails.iapTransactionsTableName,
    connectionDetails.iaaTransactionsTableName,
    connectionDetails.uaSpendsTableName,
  ]);

  return (
    <>
      <TextField
        label="IAP Transactions Table Name"
        placeholder="e.g. mygame.cohorts.iap_transactions"
        value={connectionDetails.iapTransactionsTableName}
        error={!connectionDetails.iapTransactionsTableName && isTouched.iapTransactionsTableName}
        onBlur={(e) => {
          setIsTouched((prev) => ({
            ...prev,
            iapTransactionsTableName: true,
          }));
        }}
        onChange={(e) =>
          handleConnectionDetailChange(
            'iapTransactionsTableName',
            e.target.value,
            formValues,
            handleInputChange,
          )
        }
        sx={{
          width: '100%',
        }}
        disabled={!isEditable}
      />
      <TextField
        label="	IAA Transactions Table Name"
        placeholder="e.g. mygame.cohorts.iaa_transactions"
        value={connectionDetails.iaaTransactionsTableName}
        error={!connectionDetails.iaaTransactionsTableName && isTouched.iaaTransactionsTableName}
        onBlur={(e) => {
          setIsTouched((prev) => ({
            ...prev,
            iaaTransactionsTableName: true,
          }));
        }}
        onChange={(e) =>
          handleConnectionDetailChange(
            'iaaTransactionsTableName',
            e.target.value,
            formValues,
            handleInputChange,
          )
        }
        sx={{
          width: '100%',
        }}
        disabled={!isEditable}
      />
      <TextField
        label="UA Spends Table Name"
        placeholder="e.g. mygame.cohorts.ua_spends"
        value={connectionDetails.uaSpendsTableName}
        error={!connectionDetails.uaSpendsTableName && isTouched.uaSpendsTableName}
        onBlur={(e) => {
          setIsTouched((prev) => ({
            ...prev,
            uaSpendsTableName: true,
          }));
        }}
        onChange={(e) =>
          handleConnectionDetailChange(
            'uaSpendsTableName',
            e.target.value,
            formValues,
            handleInputChange,
          )
        }
        sx={{
          width: '100%',
        }}
        disabled={!isEditable}
      />
    </>
  );
};

export default BigQueryFields;
